var error = {
  translation: {
    error: {
      coreNotFound: 'Nepodařilo se načíst základní nastavení',
      domainNotAllowed: 'Nelze se registrovat s e-mailem z této domény',
      emailAlreadyInUse: 'E-mail již používán',
      insufficientPermissions: 'Nedostatečná oprávnění',
      invalidCurrentPassword: 'Neplatné aktuální heslo',
      invalidPermissions: 'Vyberte alespoň jedno oprávnění',
      invalidUsernameOrPassword: 'Neplatné uživatelské jméno nebo heslo',
      localRegistrationDisabled: 'Lokální registrace uživatelů je zakázána administrátorem',
      noInternetConnection: 'Žádné připojení k internetu',
      noOidcProfileFound: 'OIDC profil nenalezen',
      policyNotAccepted: 'Přijměte prosím Podmínky služby a Zásady ochrany osobních údajů',
      registrationDisabled: 'Registrace uživatelů je zakázána administrátorem',
      serverConnectionFailed: 'Připojení k serveru selhalo',
      ssoRegistrationDisabled: 'SSO registrace je zakázána administrátorem',
      tooManyFailedAttempts: 'Příliš mnoho neúspěšných pokusů - zkuste to prosím znovu později',
      unknownError: 'Neznámá chyba, zkuste to později',
      usernameAlreadyInUse: 'Uživatelské jméno již používáno',
      weakPassword: 'Použijte prosím silnější heslo',
    },
  },
};

export { error as default };
